export default __webpack_public_path__ + "media/images/tractor-358d848ca149956c858f860768fa5520.jpg";